import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface AutocallYearlyObservationsFormFieldProps {}

export const AutocallYearlyObservationsFormField: React.FC<
  AutocallYearlyObservationsFormFieldProps
> = ({}) => {
  const { control, register } = useFormContext<{ autocall_yearly_observations: number }>()

  return (
    <FormField
      name="autocall_yearly_observations"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Autocall Yearly Observations</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput {...register('autocall_yearly_observations')} />
          </FormItem>
        )
      }}
    />
  )
}
